<template>
  <div class="uplevel">

      <div class="level_box">
        <p class="label">分销等级升级</p>
        <div class="level_goodslist">
          <ul>
            <li :class="['l_list',level_checked==list.id?'level_checked':'']" v-for="(list,index) in level_lists" :key="index" @click="level_check(list.id)">￥{{list.price}}</li>
          </ul>
        </div>
      </div>

      <div class="level_tip">
        <p class="label">说明</p>
        <ul class="">
          <li>1.  购买后将成为平台分享合伙人。。</li>
          <!-- <li>2.  购买后将成为平台分享合伙人。</li> -->
          <!-- <li>3.  股金可作为分享券，赠送好友使用。</li>
          <li>4.  入股本金将在一定期限后可提现。</li>
          <li>5.  更多详情点击了解<span>《股东服务协议》</span></li> -->
        </ul>
      </div>

      <div class="level_paytype">
          <p class="label">支付方式</p>
          <div class="paytype_checkbox">
            <van-checkbox v-model="pt_checked" checked-color="#45B9BC">
              <span class="iconfont icon-weixinzhifu"></span><span>微信支付</span></van-checkbox>
          </div>
      </div>

      <div style="width:100%;margin:3rem 0;text-align:center;">
        <button class="check_btn">确认购买</button>
      </div>

  </div>
</template>

<script>
export default {
  name: "uplevel",
  components: { },
  data() {
    return {
      radio: 1,
      pt_checked: true,
      level_checked:0,
      level_lists:[
        {id:0,price:3000},
        {id:1,price:6000},
        {id:2,price:9000}
      ]
    }
  },
  mounted() {

  },
  methods: {
    level_check(id){
      console.log(id);
      this.level_checked = id;
    }
  }
};
</script>
<style scoped>
  .uplevel{
    font-size:.75rem;
    color:#595959;
  }
  .label{
    background-color:white;
    padding:.6rem .75rem;
    border-bottom:1px solid #eee;
  }
  .level_goodslist{
    background-color:white;
  }
  .level_goodslist ul{
    overflow:auto;
    padding:1.3rem 0;
  }
  .level_goodslist li{
    float:left;
    padding:.9rem .7rem;
    border-radius:5px;
    margin:0 4%;
    width:25%;
    color:#45B9BC;
    font-size:.9rem;
    border:1px solid #45B9BC;
  }
  .level_checked{
    background-image: linear-gradient(to bottom right, #9AD4D6, #45B9BC);
    border:1px solid #F2F2F2 !important;
    color:#F2F2F2 !important;
  }
  .level_tip,.level_paytype{
    margin-top:.5rem;
    background-color:white;
  }
  .level_tip ul{
    padding:.3rem .75rem;
  }
  .level_tip li{
    padding:.3rem 0;
    font-size:.6rem;
    color:#8F8E8E;
  }
  .paytype_checkbox{
    padding:.75rem;
  }
  .icon-weixinzhifu{
    color:rgb(9, 187, 7);
    font-size:1.4rem;
    line-height:1.4rem;
    height: 1.4rem;
    margin-right: .25rem;
  }
  .van-checkbox__label{
    display: flex!important;
    align-items: center!important;
  }
  .check_btn{
    color:#FFFFFF;
    background-color:#45B9BC;
    border-radius:4px;
    font-size:1rem;
    padding:.5rem 0;
    width:75%;
  }
  .level_tip li span{
    font-size:.6rem;
    color:#45B9BC;
  }
</style>



// WEBPACK FOOTER //
// src/views/center/uplevel.vue